import { Component, inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'app-delete-dsp-source',
  standalone: false,
  templateUrl: './delete-dsp-source.component.html',
  styleUrl: './delete-dsp-source.component.scss'
})
export class DeleteDspSourceComponent {

  public data = inject(NZ_MODAL_DATA) as { dspItems: string };

  constructor(private dialogRef: NzModalRef<DeleteDspSourceComponent>) { }

  public onCloseModal(): void {
    this.dialogRef.close(false);
  }

  public onConfirm(): void {
    this.dialogRef.close(true);
  }
}
